"use client"
import Icon from '@ant-design/icons';
import type { GetProps } from 'antd';

type CustomIconComponentProps = GetProps<typeof Icon>;

const WarningSvg = () => (
  <svg width="1em" height="1em" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M28 3.5C14.4703 3.5 3.5 14.4703 3.5 28C3.5 41.5297 14.4703 52.5 28 52.5C41.5297 52.5 52.5 41.5297 52.5 28C52.5 14.4703 41.5297 3.5 28 3.5ZM37.6523 35.5305L36.0883 37.6633C36.0543 37.7097 36.0114 37.749 35.9622 37.7788C35.9129 37.8086 35.8583 37.8284 35.8014 37.8371C35.7444 37.8457 35.6864 37.843 35.6305 37.8292C35.5746 37.8153 35.522 37.7905 35.4758 37.7563L26.4305 31.1609C26.3741 31.1205 26.3283 31.0671 26.2969 31.0052C26.2655 30.9433 26.2494 30.8748 26.25 30.8055V15.75C26.25 15.5094 26.4469 15.3125 26.6875 15.3125H29.318C29.5586 15.3125 29.7555 15.5094 29.7555 15.75V29.2852L37.5539 34.9234C37.7508 35.0602 37.7945 35.3336 37.6523 35.5305Z" fill="#F79009" />
  </svg>


)

const WarningIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={WarningSvg} {...props} />
);

export default WarningIcon